<template>
  <div class="flex max-w-xl flex-col gap-8">
    <div>
      <h1 class="text-2xl font-semibold">{{ t('title') }}</h1>
      <p class="mt-2 text-base text-gray-600">{{ t('subtitle') }}</p>
    </div>

    <div class="grid grid-cols-2 gap-x-4 gap-y-6">
      <LabeledText class="col-span-2" :label="t('bookingNumber')">
        {{ summary.bookingNumber }}
      </LabeledText>
      <LabeledText :label="t('rentalStart')">
        {{ formatDate(summary.startDate) }}
      </LabeledText>
      <LabeledText :label="t('rentalEnd')">
        {{ formatDate(summary.endDate) }}
      </LabeledText>
      <LabeledText :label="t('pickup')">
        <span class="whitespace-pre-line font-normal">{{ summary.pickupLabel }}</span>
      </LabeledText>
      <LabeledText :label="t('return')">
        <span class="whitespace-pre-line font-normal">{{ summary.dropoffLabel }}</span>
      </LabeledText>
    </div>
  </div>
</template>

<script setup lang="ts">
import LabeledText from '@/components/LabeledText.vue';
import { formatDate } from '@/hooks/use-formatted-date';
import type { ProcessSessionBookingSummaryDto } from '@carvia/ros-client-types';
import { useI18n } from 'vue-i18n';

defineProps<{
  summary: ProcessSessionBookingSummaryDto;
}>();

const { t } = useI18n();
</script>

<i18n lang="json">
{
  "en": {
    "title": "Your booking",
    "subtitle": "Please review the details with your agent.",
    "bookingNumber": "Booking no.",
    "rentalStart": "Rental Start",
    "rentalEnd": "Rental End",
    "pickup": "Pick-up",
    "return": "Return"
  },
  "de": {
    "title": "Ihre Buchung",
    "subtitle": "Bitte prüfen Sie die Details mit Ihrem Mitarbeiter.",
    "bookingNumber": "Buchung Nr.",
    "rentalStart": "Mietbeginn",
    "rentalEnd": "Mietende",
    "pickup": "Abholung",
    "return": "Rückgabe"
  },
  "es": {
    "title": "Su reserva",
    "subtitle": "Revise los detalles con su agente.",
    "bookingNumber": "Reserva n.º",
    "rentalStart": "Inicio del alquiler",
    "rentalEnd": "Fin del alquiler",
    "pickup": "Recogida",
    "return": "Devolución"
  }
}
</i18n>
